module.exports = "<div data-component=\"customer-service\">\n\t<h2 class=\"title\">Identificação do cliente</h2>\n  <app-search-client></app-search-client>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/customer-service/customer-service.component.html
// module id = ../../../../../src/app/master/customer-service/customer-service.component.html
// module chunks = main